import { render, staticRenderFns } from "./QuickConfig.vue?vue&type=template&id=3faee90e&scoped=true&"
import script from "./QuickConfig.vue?vue&type=script&lang=js&"
export * from "./QuickConfig.vue?vue&type=script&lang=js&"
import style0 from "./QuickConfig.vue?vue&type=style&index=0&id=3faee90e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faee90e",
  null
  
)

export default component.exports